/** Presentation-only return destinations shared by workflow entry, source records and staff pages. */
export function trustedWorkflowReturnRoute(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  if (
    /^\/workflow-processes\/[a-zA-Z0-9_.-]{1,120}\/dashboards\/[a-zA-Z0-9_.%-]+\/[a-zA-Z0-9_.%-]+(?:\?[^#\\]*)?$/.test(
      value,
    )
  )
    return value;
  if (value.startsWith('/workflow-processes/')) {
    if (
      value.includes('#') ||
      value.includes('\\') ||
      !/^\/workflow-processes\/[a-zA-Z0-9_.-]{1,120}(?:\?[^#]*)?$/.test(value)
    )
      return null;
    const query = new URLSearchParams(value.split('?')[1] || '');
    const keys = new Set<string>();
    const allowed = new Set([
      'view',
      'search',
      'subjectName',
      'subjectIdentifier',
      'subjectLocation',
      'version',
      'scope',
      'status',
      'step',
      'assignment',
      'sort',
      'page',
      'section',
      'history',
    ]);
    const entries: [string, string][] = [];
    query.forEach((entry, key) => entries.push([key, entry]));
    for (const [key, entry] of entries) {
      if (
        !allowed.has(key) ||
        keys.has(key) ||
        entry.length > 250 ||
        Array.from(entry).some((character) => {
          const code = character.charCodeAt(0);
          return code <= 0x1f || code === 0x7f;
        })
      )
        return null;
      keys.add(key);
      if (
        key === 'page' &&
        (!/^[1-9]\d{0,4}$/.test(entry) || Number(entry) > 10000)
      )
        return null;
      if (key === 'version' && !/^[1-9]\d*$/.test(entry)) return null;
      if (key === 'view' && !['active', 'completed', 'all'].includes(entry))
        return null;
      if (key === 'section' && !['overview', 'worklists'].includes(entry))
        return null;
      if (key === 'history' && !['true', 'false'].includes(entry)) return null;
      if (
        key === 'sort' &&
        !['activity', 'reference', 'version'].includes(entry)
      )
        return null;
      if (key === 'assignment' && !['mine', 'unassigned', ''].includes(entry))
        return null;
      if (['search', 'subjectName', 'subjectIdentifier', 'subjectLocation'].includes(key) && entry.length > 100) return null;
      if (key === 'step' && !/^[1-9]\d*:[a-zA-Z0-9_.-]+$/.test(entry))
        return null;
      if (key === 'scope' && !/^[a-zA-Z0-9_.-]+:[a-zA-Z0-9_.-]*$/.test(entry))
        return null;
    }
    return value;
  }
  return value === '/workflows/find' ||
    /^\/workflows\/runs(?:\?[^#]*)?$/.test(value) ||
    /^\/workflow-dashboards\/[1-9]\d*\/[a-zA-Z0-9_.%-]+\/[a-zA-Z0-9_.%-]+(?:\?[^#]*)?$/.test(
      value,
    )
    ? value
    : null;
}
